/* eslint-disable no-param-reassign */
import JwtDecode from 'jwt-decode';

export const assignHelper = property => function assign(state, object) {
  state[property] = object;
};

export const resetHelper = property => function reset(state) {
  state[property] = null;
};

export const fromToken = (token) => {
  try {
    return JwtDecode(token);
  } catch (_) {
    return null;
  }
};

export const fetchList = (api, mutationType) => ({ commit }) =>
  api.list().then((response) => {
    commit(mutationType, response.data.data);
    return response;
  });
